// extracted by mini-css-extract-plugin
export default {"cards":"RevenuePage_cards__2GP0d","block":"RevenuePage_block__54Hf+"};